import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import sprite from '../../../MainPage/Assents/image/SelectBed.svg';
import s from './singleBed.module.scss';
export const SingleBed = () => {
    return (_jsx("svg", Object.assign({ className: s.hotelier_options_rooms__icon_single_bed }, { children: _jsx("use", { href: `${sprite}#singleBed` }) })));
};
